import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=22d40e5b&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=22d40e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d40e5b",
  null
  
)

export default component.exports